<script>
import { mapState } from 'vuex';
import TwTitleBar from '../../../components/TwTitleBar';

export default {
  components: {
    TwTitleBar,
  },
  props: ['id'],
  data() {
    return {
      activeTab: `/ski/area/${this.id}/facts`,
      tabs: [
        { id: 1, name: 'Facts', route: `/ski/area/${this.id}/facts` },
        { id: 2, name: 'Snow Guarantee', route: `/ski/area/${this.id}/snow-guarantee` },
        { id: 5, name: 'Slope Maps', route: `/ski/area/${this.id}/slope-maps` },
        { id: 6, name: 'Pickup Places', route: `/ski/area/${this.id}/pickup-places` },
      ],
    };
  },
  computed: {
    ...mapState({
      area: state => state.areas.area,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.ski.title'), to: '', disabled: true },
        { text: this.$t('menu.ski.pages.areas.title'), to: { name: 'SkiAreas' } },
        { text: this.area.name, to: { name: 'SkiArea', params: { id: this.id } } },
      ];
    },
  },
};
</script>

<template>
  <v-content>
    <tw-title-bar
      :title="area.name"
      :breadcrumbs="breadcrumbs">
    </tw-title-bar>
    <v-container class="ski-areas">
      <v-layout fill-height row>
        <v-flex xs12>
          <v-container fluid>
            <v-card class="ski-area__card">
              <v-tabs v-model="activeTab" class="ski-area__tabs" grow fixed-tabs>
                <v-tab
                  v-for="tab in tabs"
                  :key="tab.id"
                  :to="tab.route"
                  exact>
                  {{ tab.name }}
                </v-tab>
                <v-tabs-items>
                  <v-tab-item
                    v-for="tab of tabs"
                    :transition="false"
                    :reverse-transition="false"
                    :key="tab.id"
                    :value="tab.route">
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
              <router-view></router-view>
            </v-card>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<style lang="scss">
  .ski-area {
    &__card {
      padding-bottom: 60px;
    }

    &__tabs {
      .v-tabs__wrapper {
        border-bottom: 1px solid rgba(0, 0, 0, .12);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ski/areas/SkiArea.vue